<div class="kpi-saved-views-bar d-flex flex-wrap align-items-center gap-2">
  <div class="saved-views-select-wrap d-flex align-items-center gap-2">
    <label class="form-label small mb-0 text-muted">
      {{ 'KPI.SAVED_VIEWS.SELECT_LABEL' | translate }}
    </label>
    <select
      class="form-select form-select-sm saved-views-select"
      [disabled]="disabled || saving || !scopedViews.length"
      [(ngModel)]="selectedViewId"
      (ngModelChange)="onSelectView($event)">
      <option value="">
        {{ scopedViews.length
          ? ('KPI.SAVED_VIEWS.SELECT_PLACEHOLDER' | translate)
          : ('KPI.SAVED_VIEWS.EMPTY' | translate) }}
      </option>
      <option *ngFor="let view of scopedViews" [value]="view.id">
        {{ view.name }}
      </option>
    </select>
    <button
      *ngIf="selectedViewId as viewId"
      type="button"
      class="btn btn-sm btn-outline-danger saved-view-delete-btn"
      [disabled]="disabled || saving"
      [title]="'KPI.SAVED_VIEWS.DELETE' | translate"
      (click)="confirmDeleteSelected($event)">
      <nb-icon icon="trash-2-outline"></nb-icon>
    </button>
  </div>

  <button
    type="button"
    class="btn btn-sm btn-outline-secondary ms-auto"
    [disabled]="saveDisabled"
    [title]="saveButtonTitle"
    (click)="openSaveDialog()">
    <nb-icon icon="bookmark-outline" class="me-1"></nb-icon>
    {{ 'KPI.SAVED_VIEWS.SAVE_CURRENT' | translate }}
  </button>
</div>
